export default __webpack_public_path__ + "static/media/codechef.de233a9f.svg";